import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAssetViewerContext } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
function Stats(_ref) {
  var Component = _ref.as;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAssetViewerContex = useAssetViewerContext(),
    asset = _useAssetViewerContex.asset;
  if (!asset) return null;
  return /*#__PURE__*/React.createElement(Component, {
    icon: "asset-diagram",
    as: Link,
    to: "/assets/".concat(asset.id, "/analytics/")
  }, t('analytics_team_progress'));
}
export default Stats;